import React from "react";
import { Alert } from "reactstrap";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const Toast = ({ type, message }) => {
    if (!message) return null;

    const color = type === "success" ? "success" : type === "error" ? "danger" : "secondary";
    const icon = type === "success"
        ? <FaCheckCircle size={20} className="me-2 text-success animate__animated animate__bounceIn" />
        : <FaTimesCircle size={20} className="me-2 text-danger animate__animated animate__shakeX" />;
    return (
        <div
            style={{
                position: "fixed",
                top: "30px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 1050,
                minWidth: "350px",
                maxWidth: "600px",
            }}
        >
            <Alert
                color={color}
                className="mb-0 text-center shadow"
                style={{
                    fontSize: "1.2rem",
                    fontWeight: "500",
                    padding: "1rem 1.5rem",
                }}
            >
                {icon}
                {message}
            </Alert>
        </div>
    );
};

export default Toast;
